import { AnimatedModal, Button, Input, SelectInput } from 'components'
import React, { useEffect } from 'react'
import {
  setSettingsOpen,
  useAlgoEditorSettings,
  useAlgoEditorState,
  useAppDispatch
} from 'state'

import { XIcon } from '@heroicons/react/solid'

import { AlgoEditorThemes } from '../data'
import { getLanguageById } from '../utils/getLanguage'

function SettingsModal() {
  const { settingsOpen } = useAlgoEditorState()
  const [settings, updateSettings] = useAlgoEditorSettings()
  const dispatch = useAppDispatch()

  const onClose = () => dispatch(setSettingsOpen(false))

  useEffect(() => {
    if (typeof settings.language.id === 'number') {
      updateSettings({
        language: {
          ...settings.language,
          id: getLanguageById(settings.language.id)
        }
      })
    }
  }, [updateSettings, settings])

  const handleThemeOption = (value: string) => {
    const filter = AlgoEditorThemes.filter((option) => option.id === value)

    if (filter.length > 0) {
      updateSettings({ theme: filter[0] })
    }
  }

  return (
    <AnimatedModal isOpen={settingsOpen} onClose={onClose}>
      <div className="px-6 py-2 text-white bg-zinc-800 rounded-lg w-[500px] flex flex-col justify-center ">
        <div className="flex flex-row justify-between items-center pb-2">
          <div className="text-lg font-bold my-2">Editor Settings:</div>

          <Button variant="transparent" className="p-1" onClick={onClose}>
            <XIcon className="h-5 w-5" />
          </Button>
        </div>

        <div className="flex flex-row justify-between items-center py-2">
          <div className="text-base">Mini-Map</div>
          <div className="px-2">
            <input
              className="hover:cursor-pointer rounded"
              type="checkbox"
              name="minimap"
              id="minimap"
              checked={settings.minimap}
              onChange={(e) => {
                updateSettings({ minimap: e.target.checked })
              }}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between items-center py-2">
          <div className="text-base">Word-Wrap</div>
          <div className="px-2">
            <input
              className="hover:cursor-pointer rounded"
              type="checkbox"
              name="wordwrap"
              id="wordwrap"
              checked={settings.wordWrap}
              onChange={(e) => {
                updateSettings({ wordWrap: e.target.checked })
              }}
            />
          </div>
        </div>

        <div className="flex items-center py-2">
          <div className="text-base mr-auto">Font Size</div>
          <div className="px-2">
            <Input
              className="w-52 pr-4 border border-zinc-600"
              type="number"
              label=""
              hideLabel={true}
              id="fontsize"
              name="fontsize"
              value={settings.fontSize}
              placeholder="Font Size"
              onChange={(e) => {
                updateSettings({ fontSize: e.target.valueAsNumber })
              }}
            />
          </div>
        </div>

        <div className="flex items-center py-2">
          <div className="text-base mr-auto">Theme</div>
          <div className="px-2">
            <SelectInput
              text={settings.theme.label}
              className="w-52 border border-zinc-600 rounded-lg w-52"
              options={AlgoEditorThemes}
              selected={[settings.theme.id]}
              onChangeValue={([selected]) => handleThemeOption(selected)}
            />
          </div>
        </div>
      </div>
    </AnimatedModal>
  )
}

export default SettingsModal
